export default __webpack_public_path__ + "static/4-e597812d39ee2aa76170946dfaeadfca.webp";